import { render, staticRenderFns } from "./busyness.vue?vue&type=template&id=1599fbaa&scoped=true&"
import script from "./busyness.vue?vue&type=script&lang=js&"
export * from "./busyness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1599fbaa",
  null
  
)

export default component.exports